import { useTranslation } from "react-i18next";
import { Card, CardActions, CardContent, CardHeader, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { I18N_LANGUAGES } from "src/constants";
import { useEffect, useState } from "react";

export default function SMSLanguage({
    profile,
    loading,
    error,
    isSuccess,
    onSMSLanguageUpdated
}) {
    const { t } = useTranslation();

    const [smsSettings, setSmsSettings] = useState({
        smsLanguage: '',
        locationMessage: false,
        proofOfDeliveryActive: false,
        reschduleDeliveryDate: false
    })

    const handleChange = (event) => {
        setSmsSettings(prev => ({
            ...prev,
            [event.target.name]: event.target.value
        }))
    }

    useEffect(() => {
        if (!!profile) {
            setSmsSettings({
                smsLanguage: profile?.smsLanguage,
                locationMessage: profile?.locationMessage,
                proofOfDeliveryActive: profile?.proofOfDeliveryActive,
                reschduleDeliveryDate: profile?.reschduleDeliveryDate
            })
        }
    }, [profile])

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("SMS settings")} />
            <Divider />
            <CardContent sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <FormControl>
                    <FormLabel id="choose-sms-language-group" sx={{ color: "black", fontWeight: "bold" }}>{t("Choose SMS language")}</FormLabel>
                    <RadioGroup
                        aria-labelledby="choose-sms-language-group"
                        name="smsLanguage"
                        value={smsSettings?.smsLanguage ?? ''}
                        onChange={handleChange}
                        row
                    >
                        <FormControlLabel value={I18N_LANGUAGES.en} control={<Radio />} label={t("English")} />
                        <FormControlLabel value={I18N_LANGUAGES.ar} control={<Radio />} label={t("Arabic")} />
                    </RadioGroup>
                </FormControl>
                <FormControl sx={{mt: 1}}>
                    <FormLabel sx={{ color: "black", fontWeight: "bold" }}>{t("SMS that will be sent")}</FormLabel>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={smsSettings?.proofOfDeliveryActive || false}
                                onChange={({ target: { name, checked } }) => handleChange({ target: { name, value: checked } })}
                                name="proofOfDeliveryActive"
                            />
                        }
                        label={t("Proof of Delivery")}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={smsSettings?.reschduleDeliveryDate || false}
                                onChange={({ target: { name, checked } }) => handleChange({ target: { name, value: checked } })}
                                name="reschduleDeliveryDate"
                            />
                        }
                        label={t("Reschedule Delivery")}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={smsSettings?.locationMessage || false}
                                onChange={({ target: { name, checked } }) => handleChange({ target: { name, value: checked } })}
                                name="locationMessage"
                            />
                        }
                        label={t("Location Message")}
                    />
                </FormControl>
            </CardContent>
            <Divider />
            <CardActions
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: 'row-reverse'
                }}
            >
                <LoadingButton
                    color="main"
                    variant="contained"
                    disableElevation
                    onClick={() => onSMSLanguageUpdated(smsSettings)}
                    loading={loading}
                    // disabled={profile?.smsLanguage === selected}
                    sx={{ textTransform: "none" }}
                >
                    {t("Update")}
                </LoadingButton>
                {!!error && <Typography color="error">{t(error)}</Typography>}
                {isSuccess && <Typography color="green.main">{t("Done successfully")}</Typography>}
            </CardActions>
        </Card>
    );
};